import { HTMLAttributes } from 'react'
import styles from './Spinner.module.scss'

type SpinnerProps = HTMLAttributes<HTMLSpanElement> & {
  variant?: 'buttonSpinner' | 'boldCentered'
}

const Spinner = ({ variant = 'boldCentered', ...other }: SpinnerProps) => {
  const className = `${styles.spinner} ${styles[variant]}`
  return <span className={className} {...other} />
}

export default Spinner
